<template>
    <section class="gmp-section gmp-mb-l">
        <div class="subpage-hero subpage-hero--no-padding">
            <div class="two-column-tout two-column-tout--fullbleed">
                <div class="two-column-tout__side">
                    <div class="two-column-tout__half-page two-column-tout__half-page--left">
                        <div class="two-column-tout__half-grid two-column-tout__half-grid--left">
                            <div class="two-column-tout__col">
                                <h1 class="h-c-headline h-c-headline--display-two">
                                    优化私域流量
                                </h1>
                                <h2 class="h-u-mb-std two-column-tout__description">
                                    企业可以有效地提高群组的活跃度，增加群成员的参与感和互动性，从而为企业带来更高的客户黏性和潜在的销售机会。
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="two-column-tout__side">
                    <div class="two-column-tout__image two-column-tout__image--right">
                        <picture>
                            <img src="@/assets/img/ds_special.png" alt="The finer points." class="gmp-no-grab " >
                        </picture>
                    </div>
                </div>

            </div>

        </div>



    </section>

</template>

<script>
    export default {
        name: "WIN_two_column_fullbleed"
    }
</script>

<style lang="less">
    h2{
        font-size: 18px;
        font-weight: 300;
        margin-block-start: 0.83em;
        margin-block-end: 0.83em;
        margin-inline-start: 0px;
        margin-inline-end: 0px;
    }

</style>